/* SET STATE */
export const SET_STATE_USER = "SET_STATE_USER"

/* USERS */
export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"

/* OPERATIVE */
export const GET_OPERATIVES = "GET_OPERATIVES"
export const GET_OPERATIVES_SUCCESS = "GET_OPERATIVES_SUCCESS"
export const GET_OPERATIVES_FAIL = "GET_OPERATIVES_FAIL"

/* TECHADVISOR */
export const GET_TECHADVISORS = "GET_TECHADVISORS"
export const GET_TECHADVISORS_SUCCESS = "GET_TECHADVISORS_SUCCESS"
export const GET_TECHADVISORS_FAIL = "GET_TECHADVISORS_FAIL"

/* USER */
export const GET_USER = "GET_USER"
export const GET_USER_SUCCESS = "GET_USER_SUCCESS"
export const GET_USER_FAIL = "GET_USER_FAIL"

/**
 * ADD USER
 */
 export const ADD_NEW_USER = "ADD_NEW_USER"
 export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
 export const ADD_USER_FAIL = "ADD_USER_FAIL"

 /**
 * UPDATE USER
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * DELETE USER
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"

 /**
 * UPDATE USER CHECK
 */
  export const UPDATE_USER_CHECK = "UPDATE_USER_CHECK"

  export const UPDATE_TECHADVISOR_CHECK = "UPDATE_TECHADVISOR_CHECK"

  export const UPDATE_OPERATIVE_CHECK = "UPDATE_OPERATIVE_CHECK"